module.exports = __webpack_public_path__ + "img/value-blocks-slider-lincoln.afe4f2f0.png";